// CORE
export const DEFAULT_FLOW_NAME = 'dFlow';
export const NEXT = 'NEXT';
export const PREV = 'PREV';
export const ERROR = 'ERROR';
